import { z } from 'zod';

export const blacklistStatusResponseSchema = z.object({
  jti: z.string(),
  blacklisted: z.boolean(),
  redisHit: z.boolean(),
  jpaHit: z.boolean(),
  blacklistedAt: z.string().nullable(),
  expiresAt: z.string().nullable(),
  reason: z
    .enum(['LOGOUT', 'ROTATION', 'PASSWORD_CHANGE', 'ADMIN_REVOKE'])
    .nullable(),
  blacklistedBy: z.string().nullable(),
  source: z.enum(['REDIS-PRIMARY', 'JPA-FALLBACK', 'NOT-FOUND']),
});

export const activeRefreshTokenSchema = z.object({
  jti: z.string(),
  issuedAt: z.string(),
  expiresAt: z.string(),
  rotatedFrom: z.string().nullable(),
});

export const revokedJtiSchema = z.object({
  jti: z.string(),
  blacklistedAt: z.string(),
  reason: z.enum(['LOGOUT', 'ROTATION', 'PASSWORD_CHANGE', 'ADMIN_REVOKE']),
});

export const sessionRevocationSummarySchema = z.object({
  userId: z.number(),
  email: z.string(),
  activeRefreshTokens: z.array(activeRefreshTokenSchema),
  recentlyRevoked: z.array(revokedJtiSchema),
});

/** jti lookup form schema */
export const jtiLookupFormSchema = z.object({
  jti: z.string().min(1, 'jti를 입력해 주세요'),
});
export type JtiLookupFormValues = z.infer<typeof jtiLookupFormSchema>;

/** userId sessions form schema */
export const sessionLookupFormSchema = z.object({
  userId: z
    .string()
    .min(1, 'userId를 입력해 주세요')
    .regex(/^\d+$/, '숫자만 입력해 주세요'),
});
export type SessionLookupFormValues = z.infer<typeof sessionLookupFormSchema>;

export type BlacklistStatusResponseSchema = z.infer<typeof blacklistStatusResponseSchema>;
export type SessionRevocationSummarySchema = z.infer<typeof sessionRevocationSummarySchema>;
